import React,{useContext, useState, useEffect} from 'react';
import { auth } from '../firebase/firebaseConfig';
import { onAuthStateChanged } from "firebase/auth";
import { dotoniwoofApi } from '../api/dotoniwooApi';



const AuthContext = React.createContext();


const useAuth = () => {
    return useContext(AuthContext);
  }

const AuthProvider = ({children}) => {

    const [user, changeUser] = useState();
    const [rol, setRol] = useState();
    const [charge, changeCharge] = useState(true);

    const getRol = async (user) => {
        if(user !== null ){
        const {data} = await dotoniwoofApi.get(`user.php/${user.email}`);
        setRol(data.message[0].id_role);
    }
    }

    useEffect(()=>{
        const cancelSubscription = onAuthStateChanged(auth, (user) => {
            changeUser(user);
            changeCharge(false);
            getRol(user);
            
        });
        return cancelSubscription;
    }, []);

    return ( 
        <AuthContext.Provider value={{user, rol}}>
            {!charge && children}
        </AuthContext.Provider>
     );
    }
export {AuthProvider, AuthContext, useAuth};